import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDown, ArrowUp, ArrowRight, ArrowLeft, ArrowDownRight, ArrowUpRight, ArrowDownLeft, ArrowUpLeft } from 'lucide-react';
import './GradientPicker.css';

interface GradientPickerProps {
  direction: number; // 0, 45, 90, 135, 180, 225, 270, 315
  onChange: (direction: number) => void;
  label?: string;
}

export const GradientPicker: React.FC<GradientPickerProps> = ({ direction, onChange, label }) => {
  const { t } = useTranslation('create');

  const buttons = [
    { dir: 315, Icon: ArrowUpLeft, tKey: 'create.design.gradient.315' },
    { dir: 0, Icon: ArrowUp, tKey: 'create.design.gradient.0' },
    { dir: 45, Icon: ArrowUpRight, tKey: 'create.design.gradient.45' },
    { dir: 270, Icon: ArrowLeft, tKey: 'create.design.gradient.270' },
    { dir: null, Icon: null, tKey: '' }, // Center
    { dir: 90, Icon: ArrowRight, tKey: 'create.design.gradient.90' },
    { dir: 225, Icon: ArrowDownLeft, tKey: 'create.design.gradient.225' },
    { dir: 180, Icon: ArrowDown, tKey: 'create.design.gradient.180' },
    { dir: 135, Icon: ArrowDownRight, tKey: 'create.design.gradient.135' },
  ];

  return (
    <div className="gradient-picker-container">
      {label && <span className="gradient-picker-label">{label}</span>}
      <div className="gradient-picker-grid">
        {buttons.map((btn, i) => {
          if (btn.dir === null) {
            return <div key={i} className="gradient-picker-center" />;
          }
          return (
            <button
              key={btn.dir}
              className={`gradient-btn ${direction === btn.dir ? 'active' : ''}`}
              onClick={() => { onChange(btn.dir); }}
              aria-label={t(btn.tKey, `Angle ${btn.dir}`)}
            >
              <btn.Icon size={16} />
            </button>
          );
        })}
      </div>
    </div>
  );
};
